// extracted by mini-css-extract-plugin
export default {"contextMenu":"fileStatus_contextMenu__2mbLo","contextMenuItem":"fileStatus_contextMenuItem__6Sl4r"};